module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Blincoe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Nicholas Blincoe is an author, critic and screenwriter. His many novels include the highly-acclaimed Manchester Slingback, which won the CWA Silver Dagger award in 1998. Born in Rochdale, he attended the University of Warwick, where he completed a PhD in contemporary European philosophy.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tx5YFV/tc-custom/9781910859469.jpg?1705236026636",
      "alt": "This image is the cover for the book Manchester Slingback"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Manchester Slingback\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("A successful man confronts his hustler youth when an old friend is murdered in this crime novel exploring the gritty gay Village of ’80s Manchester.")])]), _c('p', [_vm._v(" At thirty-four years old, Jake Powell is a consummate professional in charge of an upscale casino in the West End of London. But fifteen years ago, Jake was hustling on the fringes of Manchester’s gay Village: running wild with a crowd of rentboys, purse-snatchers and disco trash; sleeping with anyone and everything. ")]), _vm._v(" In those days, Jake did a lot of things he’s not proud of. And what little he does remember he’d prefer to forget. But when Detective Inspector Davey Green takes a sudden and unexpected interest in his past, Jake is forced to confront the dirty secrets that led to the murder of his best friend . . . \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0